import { useEffect } from "react";
import { setPollingActive } from "./eventMutateSlice";
import { useAppDispatch } from "../../../hooks/useTypedSelector";

/**
 * use this hook to active the polling on the page you want
 * it will be active until the component is unmounted
 */
export const usePollingHook = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPollingActive(true));

    return () => {
      dispatch(setPollingActive(false));
    };
  }, []);
};
